module.exports = __webpack_public_path__ + "ff23fcd364f43f98a65362a21a874131.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/justin-falcone.jpg
 ** module id = 415
 ** module chunks = 0
 **/